enum MaxWidthEnum {
    None = 'none',
    Sm = 'sm',
    Md = 'md',
    Lg = 'lg'
}

export default MaxWidthEnum
